import { render, staticRenderFns } from "./ShopPresetStatus.vue?vue&type=template&id=2300106d"
import script from "./ShopPresetStatus.vue?vue&type=script&lang=js"
export * from "./ShopPresetStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports